<template>
    <div class="flex flex-col min-h-screen px-5 bg-black bg-opacity-90 p-10 ">
        <div class="max-w-md place-self-center mb-20">
            <img
                class="mx-auto pt-5"
                v-bind:src="$page.props.white_label.data.logo_black"
                width="200"
            />
            <h2 class="font-semibold text-xl text-white text-center mt-5">
                QR Code de Pagamento Pix
            </h2>
            <div class="mx-5 text-left">
                <span class="text-sm leading-none text-gray-400">
                    Prontinho! Confirmamos o seus dados, Escaneie o QR code exibido ou copie o código pelo botão abaixo para concluir o pagamento Pix de maneira prática e segura.
                </span>
            </div>

            <div class="mx-10">
                <img alt="qrcode" :src="`data:image/png;base64, ${data.qrcode}`" class="w-100 h-100 mx-auto bg-white p-5 m-5">
            </div>

            <div class="rounded-xl bg-gray-500 bg-opacity-20 m-3 py-4 text-center">
                <span class="text-green-400 text-sm">Código QR gerado com sucesso!</span>
            </div>
        </div>

        <div class="fixed bottom-10 place-self-center">
            <button class="w-36 text-xs text-white md:text-sm font-bold py-3 px-3 md:px-6 rounded-full
                uppercase border border-white hover:bg-yellow-400 object-center"
                    @click="toClipboard">
                <i class="fas fa-copy"/> COPIAR
            </button>
        </div>
    </div>
</template>
<script>

export default {
    props: ['data'],
    methods:{
        toClipboard: function () {
            console.log(this.data.emv);
            this.$clipboard(this.data.emv);
            this.$toast.open({
                message: 'Código copia e cola copiado com sucesso.',
                type: 'success',
                duration: 5000,
                position: 'top-right'
            });
        }
    }
}


</script>
